import axios from "axios";

// CLASSES
import AppConfig from "@classes/AppConfig";

export default function apiRequest(path, data, props = {}) {
  if (!data) {
    data = {};
  }

  let apiUrl = AppConfig.get("apiUrl");
  if (apiUrl === "/") {
    apiUrl = window.location.protocol + "//" + window.location.hostname;
  }

  if (process.env.NODE_ENV === "development") {
    const apiServerPort = AppConfig.get("developmentOptions").apiServerPort;
    apiUrl = apiServerPort ? apiUrl + ":" + apiServerPort : apiUrl;
  }

  const url = path[0] === "/" ? apiUrl + path : apiUrl + "/" + path;
  const headers = {};

  const config = {
    method: "post",
    data,
    url,
    ...props,
    headers: { ...headers, ...props.headers }
  };

  return new Promise((resolve, reject) => {
    axios(config)
      .then(response => {
        if (typeof response.data === "string") {
          reject(new Error(response.data));
          return;
        }

        if (response.data.success === true) {
          resolve(response.data.result);
        } else {
          reject(response.data.error);
        }
      })
      .catch(e => {
        console.log(e);
        reject(e);
      });
  });
}



// WEBPACK FOOTER //
// ./src/helpers/api.js